import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import endpoints from "../../api/endpoints";
import { Site } from "./sitesSlice";

/**
 * Sites de vente et d'expédition affectés au représentant connecté par l'administration.
 * Réponse de GET /Sites/mySites : { SitesVente: Site[], SitesExpedition: Site[] }.
 */
interface MySitesResponse {
  SitesVente?: Site[];
  SitesExpedition?: Site[];
}

interface MySitesState {
  sitesVente: Site[];
  sitesExpedition: Site[];
  loaded: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: MySitesState = {
  sitesVente: [],
  sitesExpedition: [],
  loaded: false,
  loading: false,
  error: null,
};

export const fetchMySites = createAsyncThunk("mySites/get", async () => {
  const response = await axiosInstance.get<MySitesResponse>(endpoints.sites.mySites);
  const data = response.data || {};
  return {
    sitesVente: Array.isArray(data.SitesVente) ? data.SitesVente : [],
    sitesExpedition: Array.isArray(data.SitesExpedition) ? data.SitesExpedition : [],
  };
});

const mySitesSlice = createSlice({
  name: "mySites",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMySites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMySites.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.sitesVente = action.payload.sitesVente;
        state.sitesExpedition = action.payload.sitesExpedition;
      })
      .addCase(fetchMySites.rejected, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.error = action.error.message || "Failed to fetch assigned sites!";
      });
  },
});

export default mySitesSlice.reducer;
